import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import { Payment } from '../../../models/Payment';
import { AttachMoney as MoneyIcon, TrendingUp as TrendingUpIcon, AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

interface PaymentSummaryProps {
    payments: Payment[];
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({ payments }) => {
    const totalRevenue = payments.reduce((sum, payment) => sum + payment.amount, 0);
    const totalCost = payments.reduce((sum, payment) => sum + (payment.cost || 0), 0);
    const totalProfit = totalRevenue - totalCost;
    const profitMargin = totalRevenue > 0 ? (totalProfit / totalRevenue) * 100 : 0;

    return (
        <Box sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h6" gutterBottom>
                Payment Summary
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <MoneyIcon color="primary" sx={{ fontSize: 40 }} />
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">
                                Total Revenue
                            </Typography>
                            <Typography variant="h5">
                                ${totalRevenue.toLocaleString()}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <AccountBalanceIcon color="error" sx={{ fontSize: 40 }} />
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">
                                Total Cost
                            </Typography>
                            <Typography variant="h5">
                                ${totalCost.toLocaleString()}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                        <TrendingUpIcon color="success" sx={{ fontSize: 40 }} />
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">
                                Total Profit
                            </Typography>
                            <Typography variant="h5">
                                ${totalProfit.toLocaleString()}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Margin: {profitMargin.toFixed(1)}%
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default PaymentSummary; 